import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/errorOverlay/errorOverlay.sss';

export default class ErrorOverlay extends Component {

	render({ copy, buttonClass, errorTitle, errorDescription, show, imageRegionRoot, onBackClick }) {

		return (
			<div class={joinClasses(s.container, show && s.show)}>
				<div class={s.content}>
					<h3 class={joinClasses(s.title, 'xlargeB')}>{errorTitle}</h3>
					<p class={joinClasses(s.description, 'medium')}>{errorDescription}</p>
				</div>
				<img class={s.logo} src={`${imageRegionRoot}/tt.webp`} />
				<button class={joinClasses(s.back, buttonClass)} onClick={onBackClick} ariaLabel="back">
					{copy.$AR_NOT_SUPPORTED_BACK}
				</button>
			</div>
		);
	}
}
